export const asc = 'asc';
export const perPage = 25;
export const maxImages = 5;
export const desc = 'desc';
export const sortColumn = 'id';
export const direction = 'desc';
export const shcAccessToken = 'shc_access_token';


// Product Constants

export const color = 'color';
export const brand = 'brand';
export const type = 'type';
export const category = 'category';
export const condition = 'condition';
export const size = 'size';

export const premium = 'Premium';
export const excellent = 'Excellent';
export const good = 'Good';
export const normal = 'Normal';
export const poor = 'Poor';

export const followers = 'followers';
export const following = 'following';

// Offer Constants

export const STATUS_CLOSED = 'CLOSED';
export const OFFER_TYPE_SWAP = 'SWAP';
export const OFFER_TYPE_SWAP_REQUEST = 'SWAP_REQUEST';
export const STATUS_COUNTER = 'COUNTER';
export const STATUS_ACCEPTED = 'ACCEPTED';
export const STATUS_REJECTED = 'REJECTED';
export const STATUS_CANCELED = 'CANCELED';
export const STATUS_PROCESSING = 'PROCESSING';
export const OFFER_TYPE_PRICE_DISCOUNT = 'PRICE_DISCOUNT';
export const SWAP_REQUEST_COIN_PRICE = 1;
export const SWAP_REQUEST_EUR_PRICE = 1.29;

// product size Constants

export const SIZE_CLOTHING_MEN_WOMEN = 'size_clothing_men_women';
export const SIZE_CLOTHING_CHILDREN = 'size_clothing_children';
export const SIZE_SHOE_MEN = 'size_shoe_men';
export const SIZE_SHOE_WOMEN = 'size_shoe_women';
export const SIZE_SHOE_CHILDREN = 'size_shoe_children';
